<template>
  <el-container>
    <el-header class="table-header">
      <el-button class="btn" type="primary" size="mini" @click="submit">{{$t('common.Save')}}</el-button>
<!--      <el-button class="btn" size="mini" @click="cancel">取 消</el-button>-->
    </el-header>
    <el-main class="table-main">
    <el-form ref="form" :rules="CommitForm" label-width="80px" :model="form" size="mini" class="table-form">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item :label="$t('common.Code')" prop='code'>
            <el-input v-model="form.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('common.Name')" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('base.info.org.Type')" prop="type">
              <el-select v-model="form.type">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('base.info.org.Parent')" prop="parentName">
            <el-input v-model="parent.name" readonly>
              <el-button slot="append" icon="el-icon-search" @click="updateParent"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('common.Remark')" prop="remark">
            <el-input v-model="form.remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('common.Status')" prop="status">
            <template>
              <el-radio-group v-model="form.status">
                <el-radio :label="40">{{$t('common.Disable')}}</el-radio>
                <el-radio :label="50">{{$t('common.Normal')}}</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    </el-main>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-input v-model="searchByName" :placeholder="$t('base.info.org.SearchByName')" size="small" style="width:88%;"></el-input>&nbsp;&nbsp;<el-button
      size="small" type="primary" @click="serachByName">{{$t('common.Search')}}
    </el-button>
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width:100%">
        <el-table-column
          type="index"
        >
        </el-table-column>
        <el-table-column prop="code" :label="$t('common.Code')" align="center">
        </el-table-column>
        <el-table-column prop="name" :label="$t('common.Name')" align="center">
        </el-table-column>
      </el-table>
      <div align="center">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          layout="prev, pager, next"
          :total="pageInfo.count"
          :current-page="pageInfo.curIndex"
          :page-size="pageInfo.pageCount">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">{{$t('common.Cancel')}}</el-button>
        <el-button type="primary" @click="selectSubmit" size="mini">{{$t('common.Ok')}}</el-button>
      </div>
    </el-dialog>

  </el-container>
</template>
<style>
  .btn {
    float: right;
    margin: 5px;
  }
  .row2 {
    padding-left: 10px;
  }
</style>

<script>
import Cookies from 'js-cookie'

export default {
  data () {
    return {
      form: {
        status: 50
      },
      tableData: [],
      title: '',
      searchByName: '',
      dialogStatus: '',
      parent: [],
      currentRow: '',
      options: [{
        value: '数据字典配置',
        label: '数据字典配置'
      }, {
        value: 'system_conf',
        label: 'system_conf'
      }, {
        value: 'org_type',
        label: 'org_type'
      }],
      dialogFormVisible: false,
      CommitForm: {
        name: [{required: true, trigger: 'blur', message: '菜单名称不能为空'}],
        code: [{required: true, trigger: 'blur', message: '菜单编码不能为空'}]
      },
      pageInfo: {
        pageCount: 10, // 一页显示数目
        curIndex: 1, // 当前页数
        count: 10// 总条目数
      }
    }
  },
  methods: {
    currentChange (val) {
      this.convert(this.pageInfo.pageCount, val - 1, this.searchByName)
    },
    sizeChange (val) {
      this.convert(val, 0, this.searchByName)
    },
    selectSubmit () {
      this.parent = this.currentRow
      this.dialogFormVisible = false
    },
    updateParent () {
      this.dialogFormVisible = true
      this.title = this.$t('base.info.org.ChooseParent')
      this.convert(this.pageInfo.pageCount, 0, this.searchByName)
    },
    serachByName () {
      let param = {
        data: {
          name: this.searchByName
        },
        pageSize: this.pageInfo.pageCount,
        pageIndex: 0
      }
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/org/findByCondition',
        data: JSON.stringify(param),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`),
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        console.log(response)
        this.pageInfo.curIndex = 1
        this.pageInfo.count = response.data.count
        this.tableData = response.data.data
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    handleCurrentChange (val) {
      this.currentRow = val
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.parentCode = this.parent.code
          let param = {
            data: this.form,
            pageIndex: 1,
            pageSize: 10
          }
          this.$axios({
            method: 'post',
            url: this.global.BASE_INFO + '/org/insertOrg',
            data: JSON.stringify(param),
            headers: {
              certificate: Cookies.get(`token_${window.location.port}`),
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error'
              })
            }
            this.$router.push({path: '/org'})
            let tabItem = this.$store.getters.rightNav
            this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        }
      })
    },
    cancel () {
      this.$router.push({path: '/org'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    convert (size, indexPage, name) {
      this.$api.orgList.findAllByString(this.qs.stringify({type: 'select'})).then((response) => {
        this.tableData = response.data.data
        this.pageInfo.curIndex = response.data.curIndex + 1
        this.pageInfo.count = response.data.count
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    selectParent () {
      this.dialogFormVisible = true
      this.title = '选择父类'
      this.convert(this.pageInfo.pageCount, 0, this.searchByName)
    }
  },
  message () {
    const h = this.$createElement
    this.$notify({
      title: '提示',
      message: h('i', {style: 'color: teal'}, ''),
      duration: 6000
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/org/addOrg.vue